module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightIt.0ce586f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightIt.svg
// module id = 331
// module chunks = 3